import { Component } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { environment } from 'src/environments/environment'

@Component({
  selector: 'app-tailor',
  standalone: true,
  imports: [],
  templateUrl: './tailor.component.html',
  styleUrl: './tailor.component.scss'
})
export class TailorComponent {
  bourneUrl: SafeResourceUrl

  constructor(sanitizer: DomSanitizer) {
    this.bourneUrl = sanitizer.bypassSecurityTrustResourceUrl(environment.bourneUrl)
  }
}
